import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import CameraSettingsTable from './CameraSettingsTable';
import ApiVersion from './ApiVersion';

import { fetchConfigs } from './actions';

import style from './style.module.scss';

const CameraConfigs = ({
  cameras,
  error,
  fetchConfigsAction,
}) => {
  useEffect(() => {
    fetchConfigsAction();
  }, []);

  if (error) {
    return (
      <h3>
        Error Fetching Cameras:
        {' '}
        {error.message}
      </h3>
    );
  }

  return (
    <>
      <div className="pageHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4>Camera Configs</h4>
        <ApiVersion />
      </div>
      <div className={style.MainContent}>
        <CameraSettingsTable cameras={cameras} />
      </div>
    </>
  );
};

export default connect(
  ({ cameraConfigs: { cameras, error } }) => ({ cameras, error }),
  { fetchConfigsAction: fetchConfigs },
)(CameraConfigs);
